"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardStoreProvider = exports.useDashboardSelector = exports.useDashboardDispatch = exports.ReactDashboardContext = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_redux_1 = require("react-redux");
var DashboardEventsContext_1 = require("./DashboardEventsContext");
var useInitializeDashboardStore_1 = require("./useInitializeDashboardStore");
/**
 * @alpha
 */
exports.ReactDashboardContext = react_1.default.createContext(null);
/**
 * @alpha
 */
exports.useDashboardDispatch = react_redux_1.createDispatchHook(exports.ReactDashboardContext);
/**
 * Hook for retrieving data from the dashboard state.
 *
 * @example
 * Example how to obtain all insights stored on the dashboard:
 *
 * ```tsx
 * import { useDashboardSelector, selectInsights } from "@gooddata/sdk-ui-dashboard";
 *
 * const CustomDashboardWidget = () => {
 *   const insights = useDashboardSelector(selectInsights);
 *
 *   return (
 *      <pre>{JSON.stringify(insights, null, 2)}</pre>
 *   );
 * }
 * ```
 *
 * @public
 */
exports.useDashboardSelector = react_redux_1.createSelectorHook(exports.ReactDashboardContext);
/**
 * @internal
 */
exports.DashboardStoreProvider = function (props) {
    var dashboardStore = useInitializeDashboardStore_1.useInitializeDashboardStore(props);
    var additionalReduxContext = props.additionalReduxContext;
    if (!dashboardStore) {
        return null;
    }
    if (additionalReduxContext != undefined && additionalReduxContext !== exports.ReactDashboardContext) {
        /*
         * Setting store into multiple contexts is essential in environments where a dynamically loaded
         * dashboard engine is integrated into an application that adds additional embedded, local plugins
         * which use Redux hooks (useDashboardSelector, useDashboardDispatch)
         *
         * Such local code is typically built against a local version of the sdk-ui-dashboard and has
         * different redux context providers from those used by dynamically loaded engine bundle.
         *
         * When the local code uses redux hooks, it will explode because they look into a different context
         * where the store is unset.
         */
        return (react_1.default.createElement(react_redux_1.Provider, { store: dashboardStore.store, context: exports.ReactDashboardContext },
            react_1.default.createElement(react_redux_1.Provider, { store: dashboardStore.store, context: additionalReduxContext },
                react_1.default.createElement(DashboardEventsContext_1.DashboardEventsProvider, { registerHandler: dashboardStore.registerEventHandler, unregisterHandler: dashboardStore.unregisterEventHandler }, props.children))));
    }
    return (react_1.default.createElement(react_redux_1.Provider, { store: dashboardStore.store, context: exports.ReactDashboardContext },
        react_1.default.createElement(DashboardEventsContext_1.DashboardEventsProvider, { registerHandler: dashboardStore.registerEventHandler, unregisterHandler: dashboardStore.unregisterEventHandler }, props.children)));
};
//# sourceMappingURL=DashboardStoreProvider.js.map